import { ICategoryState } from "@/services/store/category/category-types";

export const state: ICategoryState = {
  data: [],
  loading: false,
  error: null,
};
